import CurriculumView from './CurriculumView';

export default CurriculumView;
